module.exports = __webpack_public_path__ + "static/GPU.68726a6a.png";